import React, { ReactNode } from 'react';

import RoomMenuIcon from '@atlaskit/icon/glyph/room-menu';
import Tooltip from '@atlaskit/tooltip';

import { useConsentBanner } from 'src/app/navigation-provider';
import messages from 'src/app/sidebar/sidebar.i18n';
import Sidebar, {
  CollapsedContentProps,
  SidebarContent,
  ResizeProps,
} from 'src/components/sidebar';
import { BANNER_HEIGHT } from 'src/constants/navigation';
import { useIntl } from 'src/hooks/intl';

import {
  SIDEBAR_COLLAPSED_WIDTH,
  SIDEBAR_MIN_EXPANDED_WIDTH,
  SIDEBAR_MAX_EXPANDED_WIDTH,
} from '../constants';

import * as styles from './sidebar.style';

export type SidebarProps = {
  expandedWidth: number;
  collapsedContent: SidebarContent[];
  expandedContent: SidebarContent[];
  isCollapsed: boolean;
  onResize: (props: ResizeProps) => void;
  tabs?: ReactNode;
  onCollapsedContentClick: (props: CollapsedContentProps) => void;
  isBannerOpen: boolean;
};

function GlobalSidebar({ isBannerOpen, ...props }: SidebarProps): JSX.Element {
  const intl = useIntl();
  const { consentBannerHeight } = useConsentBanner()[0];
  const topOffset = isBannerOpen
    ? BANNER_HEIGHT + consentBannerHeight
    : consentBannerHeight;

  const icon = (
    <Tooltip
      position="left"
      content={intl.formatMessage(messages.expandIconTooltip)}
    >
      <RoomMenuIcon label={intl.formatMessage(messages.expandIconTooltip)} />
    </Tooltip>
  );

  return (
    <styles.Container data-qa="sidebar-container" topOffset={topOffset}>
      <Sidebar
        ariaLabel={intl.formatMessage(messages.sidebarLabel)}
        collapsedWidth={SIDEBAR_COLLAPSED_WIDTH}
        icon={icon}
        minExpandedWidth={SIDEBAR_MIN_EXPANDED_WIDTH}
        maxExpandedWidth={SIDEBAR_MAX_EXPANDED_WIDTH}
        resizable
        toggleButtonCollapseLabel={intl.formatMessage(
          messages.toggleButtonCollapseLabel
        )}
        toggleButtonExpandLabel={intl.formatMessage(
          messages.toggleButtonExpandLabel
        )}
        {...props}
      />
    </styles.Container>
  );
}

export default GlobalSidebar;
